import Typography from "@mui/material/Typography";

import { getSemanticScore } from "@app/common/utils";

import Stack from "@rui/Stack";

import SemanticScoreChip from "../SemanticScoreChip";

const TimeSeriesChartLabel = ({ score }: { score?: number | null }) => (
  <Stack direction="row" variant="center" spacing={0.5}>
    <Typography variant="bodyPrimaryMed" sx={{ color: "shades.neutral.700" }}>
      {score ?? "-"}
    </Typography>
    {score && <SemanticScoreChip type={getSemanticScore(score)} />}
  </Stack>
);

export default TimeSeriesChartLabel;
